
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {SenkronPlanAlan} from "@/services/senkronPlanService";
import {
  AlanSatiri,
  alanSatirlariniKur,
  alanSatirlariniPlanaCevir,
  frekansGecerliMi
} from "@/components/eicrapro/senkron/senkronAlanFrekans";

/**
 * Alan + frekans matrisi (Faz 3, DEV-2966).
 *
 * Alan listesi `TakipSorguAlanlariPicker`ın dışa açık `TakipSorguAlanlari`
 * dizisinden gelir — picker'ın kendisi değiştirilmedi, listesi kopyalanmadı.
 * Picker bir `v-autocomplete`tır ve alan başına ikinci bir değer (frekans)
 * taşıyamadığı için burada ayrı bir bileşen var; VERİ aynı kaynaktan.
 */
@Component
export default class SenkronAlanFrekansMatrisi extends Vue {
  /** Plandaki alanlar. Sıra ANLAMLIDIR ve korunur (bkz. alanSatirlariniPlanaCevir). */
  @Prop({default: () => []}) value!: Array<SenkronPlanAlan>;

  satirlar: Array<AlanSatiri> = [];
  /** Değişiklik çıktısının plandaki sırayı koruyabilmesi için giriş sırası saklanır. */
  private girisSirasi: Array<SenkronPlanAlan> = [];

  @Watch("value", {immediate: true})
  onValue(alanlar: Array<SenkronPlanAlan>) {
    // Kendi emit'imiz geri döndüğünde satırları yeniden kurmayız: kullanıcının
    // yazdığı frekans alanı odak kaybederdi.
    if (this.satirlar.length && this.ayniMi(alanlar)) return;
    this.girisSirasi = (alanlar ?? []).slice();
    this.satirlar = alanSatirlariniKur(alanlar ?? []);
  }

  private ayniMi(alanlar: Array<SenkronPlanAlan>): boolean {
    const suanki = alanSatirlariniPlanaCevir(this.satirlar, this.girisSirasi);
    return JSON.stringify(suanki) === JSON.stringify(alanlar ?? []);
  }

  get seciliSayisi(): number {
    return this.satirlar.filter((satir) => satir.secili).length;
  }

  get seciliUcretliSayisi(): number {
    return this.satirlar.filter((satir) => satir.secili && satir.ucretli).length;
  }

  get tumSeciliMi(): boolean {
    return this.satirlar.length > 0 && this.seciliSayisi === this.satirlar.length;
  }

  /**
   * Boş değer de reddedilir: `v-model.number` alanı temizlenince `""` bırakıyor ve
   * gövdeye `frekans_gun: 0` olarak düşüyordu. Kural boşu geçerli sayarsa alan
   * yeşil görünürken "Kaydet" hata veriyor — ekran ile denetim çelişiyordu.
   */
  frekansKurali(deger: any): boolean | string {
    return frekansGecerliMi(deger) || "Frekans 1-365 gün arasında bir tam sayı olmalıdır.";
  }

  tumunuSec() {
    const hedef = !this.tumSeciliMi;
    this.satirlar.forEach((satir) => {
      satir.secili = hedef;
    });
    this.degisti();
  }

  degisti() {
    this.$emit("input", alanSatirlariniPlanaCevir(this.satirlar, this.girisSirasi));
  }
}
